<mat-toolbar mat-dialog-title color="primary" class="device-dialog-toolbar"
  [ngClass]="'border-color-' + Keys[deviceType]">
  <span class="device-dialog-title" [matTooltip]="externalDeviceId" [matTooltipDisabled]="!isMobile"
    #titleTooltip="matTooltip" (click)="titleTooltip.show()">{{externalDeviceId}}</span>
  <div class="mat-header-actions" *ngIf="data && data.device && !plotUrl">
    <button mat-stroked-button color="link" (click)="changeDeviceWithType(Keys.GATE)"
      *ngIf="deviceType !== Keys.GATE && itemData.gateExtDeviceId" [matTooltip]="itemData.gateExtDeviceId"
      [matTooltipShowDelay]="1000">
      <mat-icon [type]="Keys.GATE" />
    </button>
    <button mat-stroked-button color="link" (click)="changeDeviceWithType(Keys.SIMCARD)"
      *ngIf="deviceType !== Keys.SIMCARD && itemData.simExtDeviceId" [matTooltip]="itemData.simExtDeviceId"
      [matTooltipShowDelay]="1000">
      <mat-icon [type]="Keys.SIMCARD" />
    </button>
    <button mat-stroked-button color="link" (click)="changeDeviceWithType(Keys.SZT)"
      *ngIf="deviceType !== Keys.SZT && itemData.sztExtDeviceId" [matTooltip]="itemData.sztExtDeviceId"
      [matTooltipShowDelay]="1000">
      <mat-icon [type]="Keys.SZT" />
    </button>
    <button mat-stroked-button color="link" (click)="loadPlot()" *ngIf="deviceType === Keys.GATE"
      [matTooltip]="'devices.table.header.plots' | translate" [matTooltipShowDelay]="1000">
      <mat-icon>bar_chart</mat-icon>
    </button>
  </div>
  <div class="mat-header-actions" *ngIf="plotUrl">
    <button mat-stroked-button color="link" (click)="clearPlot()" *ngIf="itemData.gateExtDeviceId"
      [matTooltip]="itemData.gateExtDeviceId" [matTooltipShowDelay]="1000">
      <mat-icon>developer_board</mat-icon>
    </button>
  </div>
</mat-toolbar>
<div mat-dialog-content *ngIf="data && data.device && !plotUrl else plotDialog" id="device-tab-group">
  <mat-tab-group [(selectedIndex)]="tabIndex" #deviceTabGroup="matTabGroup">
    <mat-tab class="basic-info">
      <ng-template mat-tab-label>
        <mat-icon class="label-icon" [type]="deviceType" />
        {{ 'devices.detail.basic.title' | translate }}
      </ng-template>
      <ng-template matTabContent>
        <app-device-basic [device]="data.device" [deviceTypeData]="data.deviceTypeData" [itemData]="itemData"
          class="device-tab-content" (redirectEvent)="changeDeviceWithType($event)"
          (monitoringEvent)="navigateToMonitoring()" (editEventEmitter)="itemEditEventEmitter.emit($event)" />
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="data.device.sfDeviceAttribute">
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined">database</mat-icon>
        {{ 'devices.detail.sales-force.title' | translate }}
      </ng-template>
      <app-device-sales-force [sfDeviceAttribute]="data.device.sfDeviceAttribute" [bfAccessible]="bfAccessible"
        class="device-tab-content" (redirectEvent)="changeDeviceWithType($event)" />
    </mat-tab>
    <mat-tab *ngIf="data.device.attributes?.length">
      <ng-template mat-tab-label>
        <mat-icon class="label-icon">format_list_bulleted</mat-icon>
        {{ 'devices.detail.attributes.title' | translate }}
      </ng-template>
      <app-device-attributes [deviceAttributesData]="data.device.attributes" class="device-tab-content" />
    </mat-tab>
    <mat-tab #opstateTab="matTab" [label]="'devices.detail.opstate-items.title' | translate"
      *ngIf="data.device.operationStateItems?.length">
      <ng-template mat-tab-label>
        <mat-icon class="label-icon">format_list_numbered</mat-icon>
        {{ 'devices.detail.opstate-items.title' | translate }}
      </ng-template>
      <app-device-opstate-items #opstateItems [deviceOperationStateItemsData]="data.device.operationStateItems"
        class="device-tab-content opstate" />
    </mat-tab>
    <mat-tab #eventTab="matTab" [label]="'devices.detail.events.title' | translate" *ngIf="data.device.events?.length">
      <ng-template mat-tab-label>
        <mat-icon class="label-icon">event_note</mat-icon>
        {{ 'devices.detail.events.title' | translate }}
      </ng-template>
      <app-device-events #eventItems [deviceEventsData]="data.device.events"
        class="device-tab-content" />
    </mat-tab>
    <mat-tab [label]="'devices.detail.parameters.title' | translate" *ngIf="data.deviceParameters?.length">
      <ng-template mat-tab-label>
        <mat-icon class="label-icon">pin</mat-icon>
        {{ 'devices.detail.parameters.title' | translate }}
      </ng-template>
      <app-device-parameters [deviceParametersData]="data.deviceParameters" [editable]="editable"
        class="device-tab-content" />
    </mat-tab>
    <mat-tab [label]="'devices.detail.sensitive.title' | translate" *ngIf="data.hasSensitiveData">
      <ng-template mat-tab-label>
        <mat-icon class="label-icon">lock</mat-icon>
        {{ 'devices.detail.sensitive.title' | translate }}
      </ng-template>
      <ng-template matTabContent>
        <app-device-sensitive [externalDeviceId]="data.device.externalDeviceId" class="device-tab-content" />
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
<ng-template #plotDialog>
  <div mat-dialog-content class="plot-content" *ngIf="plotUrl else loading">
    <iframe class="plotFrame" id="plotFrame" [src]="plotUrl" title="plotFrame"></iframe>
  </div>
</ng-template>
<ng-template #loading>
  <div mat-dialog-content>
    <mat-spinner />
  </div>
</ng-template>
<mat-dialog-actions align="end">
  <button mat-flat-button class="refresh-button web-only" (click)="refresh()"
    [disabled]="!data?.device">{{'button.refresh' |
    translate}}</button>
  <button mat-flat-button class="refresh-button mobile-only" (click)="refresh()"
    [disabled]="!data?.device"><mat-icon>sync</mat-icon></button>
  <button mat-flat-button [mat-dialog-close]="true" color="primary" class="close-button">{{'button.close' |
    translate}}</button>
</mat-dialog-actions>
